import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import newsletterImg from '../../../../assets/newsletter_signup.png';
import { Controller, useForm } from 'react-hook-form';
import { Button, Checkbox } from '@bcmi-labs/react-components';
import PropTypes from 'prop-types';
import AlertBox from '../../../common/AlertBox';
import './newsletter.scss';

const Newsletter = ({ onSubmit, loading, setUserData }) => {
  const { t } = useTranslation('newsletter');
  const { handleSubmit, control, setValue, watch } = useForm();
  const newsletterApproval = watch('newsletterApproval');

  useEffect(() => {
    setUserData({ newsletterVisited: true });
  }, [setUserData]);

  return (
    <section className="newsletter">
      <img className="newsletter__image" src={newsletterImg} alt="Newsletter registration" />
      <h1 className="arduino-typography-large">{t('newsletter:title')}</h1>
      <p className="description">{t('newsletter:description')}</p>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="privacy-row">
          <Controller
            render={({ onChange, onBlur, value }) => (
              <Checkbox
                label={t('register:newsletter')}
                onBlur={onBlur}
                onChange={(e) => {
                  onChange(e.target.checked);
                  if (!e.target.checked) {
                    setValue('marketingEducation', false);
                    setValue('marketingProfessional', false);
                  }
                }}
                isSelected={value}
                withoutStatus={true}
              />
            )}
            name="newsletterApproval"
            control={control}
            defaultValue=""
          />
        </div>
        {newsletterApproval && (
          <>
            <span className="newsletter__marketing-subtitle">{t('newsletter:marketing_subtitle')}</span>
            <div className="marketing-choices">
              <Controller
                render={({ onChange, onBlur, value }) => (
                  <Checkbox
                    label={t('register:marketing:education')}
                    isIndeterminate={value === '-'}
                    isDisabled={value === '-'}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    isSelected={value && value !== '-'}
                    withoutStatus={true}
                  />
                )}
                name="marketingEducation"
                control={control}
                defaultValue=""
              />
              <Controller
                render={({ onChange, onBlur, value }) => (
                  <Checkbox
                    label={t('register:marketing:professional')}
                    isIndeterminate={value === '-'}
                    isDisabled={value === '-'}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    isSelected={value && value !== '-'}
                    withoutStatus={true}
                  />
                )}
                name="marketingProfessional"
                control={control}
                defaultValue=""
              />
            </div>
            <div className="newsletter__divider" />
          </>
        )}

        <div className="privacy-container privacy-container--no-margin">
          <div className="privacy-row">
            <Controller
              render={({ onChange, onBlur, value }) => (
                <Checkbox
                  label={t('register:marketing:approval')}
                  onBlur={onBlur}
                  onChange={(e) => onChange(e.target.checked)}
                  isSelected={value}
                  withoutStatus={true}
                />
              )}
              name="marketingApproval"
              control={control}
              defaultValue=""
            />
          </div>
        </div>
        <Button type="submit" loading={loading}>
          {t('newsletter:submitText')}
        </Button>
      </form>
      <AlertBox message={t('newsletter:alert')} variant="info" />
    </section>
  );
};

export default Newsletter;

Newsletter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setUserData: PropTypes.func,
};
